import React from "react";

import * as yup from "yup";

import { Input, Radio } from "clearsense-ui/components/formik";

const getLabelByValue = value => {
  switch (value) {
    case "min_data_length":
      return "Minimum Data Length";
    case "max_data_length":
      return "Maximum Data Length";
    case "data_length":
      return "Exact Data Length";
    case "datatype":
      return "Data Type";
    case "null_not_possible":
      return "Do not allow empty data";
    case "starts_with":
      return "Starts With";
    case "ends_with":
      return "Ends With";
    case "contains":
      return "Contains";
    default:
      return "";
  }
};

const ATTRIBUTE_TYPES = [
  { label: getLabelByValue("min_data_length"), value: "min_data_length" },
  { label: getLabelByValue("max_data_length"), value: "max_data_length" },
  { label: getLabelByValue("data_length"), value: "data_length" },
  { label: getLabelByValue("datatype"), value: "datatype" },
  { label: getLabelByValue("null_not_possible"), value: "null_not_possible" },
  { label: getLabelByValue("starts_with"), value: "starts_with" },
  { label: getLabelByValue("ends_with"), value: "ends_with" },
  { label: getLabelByValue("contains"), value: "contains" },
];

const INITIAL_VALUES = {
  title: "",
  description: "",
  name: "",
  value: "",
  active: true,
};

const renderValueField = field_name => {
  switch (field_name) {
    case "min_data_length":
      return (
        <Input
          name="value"
          label="Minimum Length"
          placeholder="Enter Minimum Data Length"
          required
        />
      );
    case "max_data_length":
      return (
        <Input
          name="value"
          label="Maximum Length"
          placeholder="Enter Maximum Data Length"
          required
        />
      );
    case "data_length":
      return (
        <Input
          name="value"
          label="Actual Length"
          placeholder="Enter Actual Data Length"
          required
        />
      );
    case "datatype":
      return (
        <Radio name="value" label="Data Type" required>
          <Radio.Item name="value" value="alphanumeric" label="Alphanumeric" />
          <Radio.Item name="value" value="numeric" label="Numeric" />
          <Radio.Item
            name="value"
            value="letters_only"
            label="Alphabets only"
          />
        </Radio>
      );
    case "null_not_possible":
      return "";
    case "starts_with":
      return (
        <Input
          name="value"
          label="Starts with"
          placeholder="Enter value that the column starts with"
          required
        />
      );
    case "ends_with":
      return (
        <Input
          name="value"
          label="Ends with"
          placeholder="Enter value that the column ends with"
          required
        />
      );
    case "contains":
      return (
        <Input
          name="value"
          label="Contains"
          placeholder="Enter a substring that the column contains"
          required
        />
      );
    default:
      return "";
  }
};

const VALIDATION_SCHEMA = yup.object({
  title: yup.string().trim().required("Please enter a title"),
  description: yup.string().trim(),
  name: yup.object().nullable().required("Please select an attribute"),
  value: yup
    .string()
    .trim()
    .required("Value is a required field")
    .test({
      name: "check_value",
      message: "The provided value is invalid for the selected attribute",
      test: function (value) {
        switch (this?.parent?.name?.value) {
          case "min_data_length":
          case "max_data_length":
          case "data_length":
            return !isNaN(value);
          case "datatype":
            return ["alphanumeric", "numeric", "letters_only"].includes(value);
          case "starts_with":
          case "ends_with":
          case "contains":
            return typeof value === "string" && value.length !== 0;
        }
        return "";
      },
    }),
});

export {
  ATTRIBUTE_TYPES,
  renderValueField,
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
  getLabelByValue,
};
